import fetch from '@/api/fetch'

/**
 * 我的订单列表
 */
export function getOrderListReq({ params, showErrorPage }) {
  return fetch({
    method: 'post',
    url: '/my/order/queryOrderList',
    showErrorPage: showErrorPage,
    params
  })
}

/**
 * 取消订单
 */
export function getCancelReq(params) {
  return fetch({
    url: '/my/order/cancel',
    setCsrfToken: true,
    params
  })
}

/**
 * 延迟收货
 */
export function extendedDelivery(params) {
  return fetch({
    url: '/my/order/delayReceive',
    setCsrfToken: true,
    params
  })
}

/**
 * 去结算
 */
export function getSettleReq(params) {
  const bankchannel = sessionStorage.getItem('bankchannel')
  return fetch({
    url: '/my/order/settle',
    setCsrfToken: true,
    params: bankchannel ? { ...params, bankchannel } : params
  })
}

/**
 * 检查是否允许退款/退货
 */
export function checkRefundApplyReq(params) {
  return fetch({
    url: '/my/refund/checkApply',
    params
  })
}

/**
 * 查询物流状态信息
 */
export function getExpressReq(params) {
  return fetch({
    url: '/my/order/checkCodOrderExpressState',
    params
  })
}

/**
 * 确认收货
 */
export function getReceiptReq(params) {
  return fetch({
    url: '/my/order/confirmReceipt',
    setCsrfToken: true,
    params
  })
}

/**
 * 删除订单
 */
export function getDelOrderReq(params) {
  return fetch({
    url: '/my/order/delete',
    setCsrfToken: true,
    params
  })
}

/**
 * 对拼购待发货的订单进行批量查询是否有倒计时
 */
export function queryPinGouBeforeDeliver(params) {
  return fetch({
    url: '/my/order/batchQueryGroupon',
    params
  })
}

/**
 * 提醒发货
 */
export function remindShip(params) {
  return fetch({
    url: '/my/order/remindShip',
    setCsrfToken: true,
    params
  })
}

/**
 * 查询线下导购信息
 * @param params
 */
export function contactGuide(params) {
  return fetch({
    url: '/my/order/querySellerInfo',
    params
  })
}

/**
 * 查询线下取货码
 * @param params
 */
export function queryPickup(params) {
  return fetch({
    url: '/my/order/queryPickup',
    params
  })
}

/**
 * 查询线下取货码
 * @param params
 */
export function getpdf(params) {
  return fetch({
    url: 'http://172.22.225.66:8080/api/v1/etax/pdf?orderNo=1&phoneNo=1',
    params
  })
}

/**
 * 补发票、改发票
 * @param params
 */
export function saveTaxInfoReq(params) {
  return fetch({
    url: '/my/order/saveTaxInfo',
    method: 'post',
    setCsrfToken: true,
    params
  })
}

/**
 * 查询订单下面对应所有子订单信息
 * @param params
 */
export function getChildrenOrderReq(params) {
  return fetch({
    url: '/my/order/queryChildrenOrderList',
    params
  })
}
